module.exports = __webpack_public_path__ + "img/richTextStore.c0d271b5.svg";